"use client"

import { resolveStagedPreviewBackendUrl } from "@lib/util/staged-preview"
import LocalizedClientLink from "@modules/common/components/localized-client-link"
import styles from "./wipes-landing.module.css"

const cards = [
  {
    key: "freshwipes",
    href: "/products/freshwipes-agiz-kokusu-ve-plak-olusumuna-karsi-kedi-ve-kopek",
    label: "FreshWipes'i İncele",
    heading: "FreshWipes ağız bakım mendili",
    file: "vetpets-wipes-freshwipes-collection.webp",
    alt: "FreshWipes parmak mendili ile golden retriever için günlük ağız bakımı",
  },
  {
    key: "earwipes",
    href: "/products/earwipes",
    label: "EarWipes'i İncele",
    heading: "EarWipes kulak bakım mendili",
    file: "vetpets-wipes-earwipes-collection.webp",
    alt: "EarWipes parmak mendili ile French bulldog kulak çevresi bakımı",
  },
  {
    key: "eyewipes",
    href: "/products/eyewipes",
    label: "EyeWipes'i İncele",
    heading: "EyeWipes göz çevresi bakım mendili",
    file: "vetpets-wipes-eyewipes-collection.webp",
    alt: "EyeWipes ile kedinin hassas göz çevresinde nazik günlük bakım",
  },
] as const

const mediaBase = () =>
  resolveStagedPreviewBackendUrl(
    process.env.NEXT_PUBLIC_MEDUSA_BACKEND_URL,
    typeof document !== "undefined" ? document.cookie : undefined,
    typeof window !== "undefined" ? window.location.origin : undefined
  ).replace(/\/$/, "")

export default function WipesLanding() {
  const base = mediaBase()

  return (
    <main className={styles.page} aria-labelledby="wipes-landing-title">
      <h1 id="wipes-landing-title" className={styles.srOnly}>VetPets Islak Mendiller</h1>
      <div className={styles.gallery}>
        {cards.map((card, index) => (
          <section key={card.key} className={styles.section} aria-labelledby={card.key + "-title"}>
            <h2 id={card.key + "-title"} className={styles.srOnly}>{card.heading}</h2>
            <LocalizedClientLink
              href={card.href}
              className={styles.card}
              aria-label={card.label + ": " + card.heading}
            >
              <span className={styles.placeholder} aria-hidden="true" />
              <img
                className={styles.image}
                src={base + "/static/" + card.file}
                alt={card.alt}
                width={1440}
                height={810}
                loading={index === 0 ? "eager" : "lazy"}
                fetchPriority={index === 0 ? "high" : "auto"}
                decoding={index === 0 ? "sync" : "async"}
                ref={(node) => {
                  if (node?.complete) node.parentElement?.classList.add(styles.loaded)
                }}
                onLoad={(event) => event.currentTarget.parentElement?.classList.add(styles.loaded)}
              />
              <span className={styles.cta} aria-hidden="true">
                <span>{card.label}</span>
                <svg className={styles.arrow} viewBox="0 0 20 20" fill="none">
                  <path d="M4 10h11M11 6l4 4-4 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </span>
            </LocalizedClientLink>
          </section>
        ))}
      </div>
    </main>
  )
}
